module.exports = __webpack_public_path__ + "media/images/flags/pw-2f97be4f0b305d44a78be90c3bb7fc01.svg";